import initSqlJs from 'sql.js';
import { DataSource } from 'typeorm';
import {
  ContactElement,
  ContactInformation,
  Hospital,
  InformationCategory,
  InformationPage,
  InformationPageImage,
  MediaFile,
  Moment,
  News,
  Phase,
  Topic
} from '@nsk-app/models';
import { AddNewsTable1635258789259 } from '@nsk-app/migrations/AddNewsTable1635258789259';

export const sqlite = {
  initDataSource: async function() : Promise<DataSource> {

    window['SQL'] = initSqlJs;

    const entities = [
      Hospital,
      MediaFile,
      InformationCategory,
      InformationPage,
      InformationPageImage,
      ContactInformation,
      ContactElement,
      Phase,
      Topic,
      Moment,
      News
    ];

    const migrations = [
      AddNewsTable1635258789259
    ];


    return new DataSource({
      type: 'sqljs',
      // driver: sqliteConnection,
      // database: 'nsk-data',
      // version: 1,
      location: 'default',
      // synchronize: false,
      // journalMode: 'OFF',
      // mode: 'no-encryption',
      useLocalForage: false,
      entities,
      migrations
    });
  },
  useSqlJs: true
};
